import { ConfirmDialog } from "@/shared/components/ConfirmDialog";
import { useConfirmDeleteStore } from "./confirmDeleteStore";

/** Modal de exclusão montado uma vez no root da aplicação. */
export function ConfirmDeleteHost() {
  const pending = useConfirmDeleteStore((s) => s.pending);
  const loading = useConfirmDeleteStore((s) => s.loading);
  const close = useConfirmDeleteStore((s) => s.close);
  const confirm = useConfirmDeleteStore((s) => s.confirm);

  if (!pending) return null;

  return (
    <ConfirmDialog
      open
      title={pending.title}
      message={pending.message}
      confirmLabel={pending.confirmLabel}
      cancelLabel={pending.cancelLabel}
      loading={loading}
      onConfirm={confirm}
      onCancel={close}
    />
  );
}
